import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { addToCart } from '../../Cart/cartActions';
import { editPreviousProductConfiguration } from '../../ProductCustomizer/productCustomizerActions';
import FavouritesList from './components/FavouritesList';

const findUnavailableProducts = (favouritesList, products) => {
  let modifiedFavouritesList = favouritesList;
  if (products.length > 0 && favouritesList.length > 0) {
    modifiedFavouritesList = favouritesList.map((favourite) => {
      const product = products.find(
        (product) => product.product_id === favourite.flatProduct.product_id
      );
      favourite.flatProduct.is_product_available =
        product && product.is_product_available;
      return favourite;
    });
  }
  return modifiedFavouritesList;
};

const FavouritesListContainer = ({
  favouritesList,
  products,
  editPreviousProductConfiguration,
  isFromFavourites,
  addToCart,
}) => {
  const modifiedFavouritesList = findUnavailableProducts(
    favouritesList,
    products
  );
  return (
    <div>
      {modifiedFavouritesList.length > 0 && (
        <FavouritesList
          id='Favourites-FavouritesList'
          favouritesList={modifiedFavouritesList}
          editPreviousProductConfiguration={editPreviousProductConfiguration}
          isFromFavourites={isFromFavourites}
          addToCart={addToCart}
          products={products}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  favouritesList: state.favouritesReducer.favouritesList,
  isFromFavourites: state.productCustomizerReducer.isFromFavourites,
  products: state.menuReducer.products,
});

export default connect(mapStateToProps, {
  editPreviousProductConfiguration,
  addToCart,
})(FavouritesListContainer);
